import { useState, useEffect } from "react";
import firebase from "firebase/app";
import { brand } from "../brandVariables/getBandVariables";
import { Challenge } from "../types/challengeDataResponse";

export const useCurrentEventChallenges = () => {
  const [loadingNextChallenge, setLoadingNextChallenge] = useState(true);
  const [nextChallenges, setNextChallenges] = useState<Challenge[] | null>(
    null
  );
  const [loadingOngoingChallenge, setLoadingOngoingChallenge] = useState(true);
  const [ongoingChallenge, setOngoingChallenge] = useState<Challenge[] | null>(
    null
  );

  console.log(brand.client);
  console.log(brand.eventCode);

  const upComingChallengesQuery = firebase
    .firestore()
    .collection("challenges")
    .where("client", "==", brand.client)
    .where("eventCode", "==", brand.eventCode)
    .where("status", "==", "upcoming");

  const ongoingChallengesQuery = firebase
    .firestore()
    .collection("challenges")
    .where("client", "==", brand.client)
    .where("eventCode", "==", brand.eventCode)
    .where("status", "==", "ongoing")
    .limit(1);

  const fetchUpcomingData = async () => {
    console.log("Fetch upcoming challenges!");
    try {
      setLoadingNextChallenge(true);

      upComingChallengesQuery.onSnapshot((snapshotForUpcoming) => {
        if (snapshotForUpcoming.docs.length > 0) {
          const upcomingChallengesData = snapshotForUpcoming.docs.map((doc) => {
            return doc.data();
          }) as Challenge[];
          console.log(upcomingChallengesData);

          upcomingChallengesData.sort((a, b) => {
            return a.startDate.seconds * 1000 - b.startDate.seconds * 1000;
          });

          setNextChallenges(upcomingChallengesData);
        }
        setLoadingNextChallenge(false);
      });
    } catch (error) {
      setLoadingNextChallenge(false);
      console.log("Error:", error);
    } finally {
      setLoadingNextChallenge(false);
    }
  };

  const fetchOngoingData = async () => {
    console.log("Fetch ongoing challenges!");
    try {
      setLoadingOngoingChallenge(true);
      ongoingChallengesQuery.onSnapshot((snapshotForOngoing) => {
        const challenge = snapshotForOngoing.docs.map((doc) => doc.data())[0];

        if (challenge) {
          setOngoingChallenge(challenge);
        } else {
          setOngoingChallenge(undefined);
        }
        setLoadingOngoingChallenge(false);
      });
    } catch (error) {
      setLoadingOngoingChallenge(false);
      console.error("Error:", error);
    } finally {
      setLoadingOngoingChallenge(false);
    }
  };

  // Check if its init run/data connection has already been initialized
  useEffect(() => {
    fetchUpcomingData();
  }, []);

  useEffect(() => {
    fetchOngoingData();
  }, []);

  console.log("Upcoming:", nextChallenges);

  console.log(nextChallenges);

  return {
    fetchUpcomingData,
    loadingNextChallenge,
    nextChallenges,
    fetchOngoingData,
    loadingOngoingChallenge,
    ongoingChallenge,
  };
};
